<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 8H16M4 8V19C4 19.5523 4.44772 20 5 20H16M4 8L7.73333 5.2C7.90643 5.07018 8.11696 5 8.33333 5H20M16 8V20M16 8L20 5M16 20L19.6 17.3C19.8518 17.1111 20 16.8148 20 16.5V5"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>
